<script setup lang="ts">
import AppHeader from '~/components/layout/AppHeader.vue'
import AppFooter from '~/components/layout/AppFooter.vue'
</script>

<template>
  <div class="flex flex-col min-h-screen w-full bg-background text-foreground transition-colors duration-300 overflow-x-hidden">
    <AppHeader />
    
    <main class="grow pt-(--header-height)">
      <slot />
    </main>

    <AppFooter />
  </div>
</template>
